import React from 'react';
import { CardBody, CardHeader, Heading, Text, VStack } from '@chakra-ui/react';
import { localise, templateReplace } from '../../../services/lang/lang';
import InspectionDetailCard from '../upgrade/InspectionDetail/InspectionDetailCard';
import { useTokens } from '../../../context/TokenProvider';
import CreateRemoteSubmissionWrapper from './CreateRemoteSubmissionWrapper';
import ModalErrorMessageBox from '../../modules/ErrorAwareAlertBox/ModalErrorMessageBox';
import { useModalErrors } from '../../modules/Modal/ModalErrorProvider';
const RemoteSubmissionCard = ({ invite, onSubmitComplete }) => {
    const tokens = useTokens();
    const { hasErrors, errors } = useModalErrors();
    return (React.createElement(InspectionDetailCard, { "data-testid": "remote_submission_card", w: { base: '90%', sm: '90%', md: '600px' } },
        React.createElement(CardHeader, { p: 0 },
            React.createElement(ModalErrorMessageBox, { hasErrors: hasErrors, errors: errors })),
        React.createElement(CardBody, { padding: tokens.Spacing06 },
            React.createElement(VStack, { spacing: tokens.Spacing06, align: "stretch" },
                React.createElement(Heading, { mt: 0, mb: tokens.Spacing02, as: "h1", variant: "dk-800-md-4" }, localise('REMOTE_SUBMISSION_LOG_EVIDENCE')),
                React.createElement(VStack, { spacing: tokens.Spacing05, align: "stretch" },
                    React.createElement(Text, { "data-testid": "org_name_description", variant: "md-600-rg-4" }, templateReplace(localise('REMOTE_SUBMISSION_ORG_INVITED'), {
                        org: invite.organisation_name,
                        property: invite.inspection_address ?? localise('THIS_PROPERTY'),
                    })),
                    React.createElement(Text, { variant: "md-600-rg-4" }, localise('REMOTE_SUBMISSION_DESCRIPTION'))),
                React.createElement(CreateRemoteSubmissionWrapper, { onSubmitComplete: onSubmitComplete })))));
};
export default RemoteSubmissionCard;
